import { useMemo } from 'react';
import { ProfileData } from '@/types/profile';
import { ProfileFilters } from '@/hooks/useProfileFilters';
import { applyAdvancedFilters, filterProfiles } from '@/utils/profileUtils';

interface FilteredResultsPreview {
  count: number;
  isEmpty: boolean;
  statusColor: string;
}

export const useFilteredResultsPreview = (
  rawProfiles: ProfileData[],
  filters: ProfileFilters,
  userRole?: string,
  userOrientation?: string
): FilteredResultsPreview => {
  return useMemo(() => {
    if (!rawProfiles || rawProfiles.length === 0) {
      return { count: 0, isEmpty: true, statusColor: 'text-red-400' };
    }

    // Apply basic filters (role compatibility, etc.)
    let filtered = filterProfiles(rawProfiles, userRole, userOrientation);

    // Apply advanced filters
    filtered = applyAdvancedFilters(filtered, filters);

    const count = filtered.length;
    
    // Determine status color based on count
    let statusColor = 'text-green-400';
    if (count === 0) statusColor = 'text-red-400';
    else if (count <= 4) statusColor = 'text-orange-400';
    else if (count <= 20) statusColor = 'text-yellow-400';

    return {
      count,
      isEmpty: count === 0,
      statusColor
    };
  }, [rawProfiles, filters, userRole, userOrientation]);
};
